import {useFrontendTool} from "@copilotkit/react-core/v2";
import {CodeIcon} from "@project/icons-web";
import {useRouter} from "@tanstack/react-router";
import {z} from "zod";

import {ToolCallWrapper} from "../components/tool-call-wrapper";
import {focusAppOnMobile} from "../state/mobile-assistant-ui.store";

/**
 * Registry for Client-Side Tools.
 * Exposes SPA actions (like navigation, opening modals) to the AG-UI agent.
 */
export function ClientToolsRegistry() {
  const router = useRouter();

  useFrontendTool(
    {
      name: "navigateToDashboard",
      description: "Navigate the user to the ERP dashboard",
      parameters: z.object({
        path: z.string().describe("The path to navigate to, e.g. '/dashboard'"),
      }),
      handler: async (args) => {
        try {
          focusAppOnMobile();
          await router.navigate({to: args.path});

          return `Navigated to ${args.path}`;
        } catch (e) {
          return `Failed to navigate: ${e}`;
        }
      },
      render: ({status, args}) => {
        return (
          <ToolCallWrapper
            name="Navigate to Dashboard"
            title={args.path}
            status={status}
            icon={<CodeIcon className="size-4" />}
          />
        );
      },
      followUp: false,
    },
    [router],
  );

  return null;
}
